import { render } from "./manage.vue?vue&type=template&id=5b1dc3d4"
import script from "./manage.vue?vue&type=script&lang=js"
export * from "./manage.vue?vue&type=script&lang=js"

import "./manage.vue?vue&type=style&index=0&id=5b1dc3d4&scope=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__